module.exports = __webpack_public_path__ + "img/add_to_goodreads.6baec755.svg";